<script>
  export let selected = false;
  export let selectedColor = "#E8004C";
  export let unselectedColor = "#A4A7AE";
  export let size = { width: 24, height: 22 };
</script>

{#if selected}
  <svg
    width={size.width}
    height={size.height}
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.018 0.354004C12.4104 0.354004 12.7685 0.566465 12.9422 0.901691L15.8868 6.5867L22.4756 7.50463C22.8638 7.55869 23.1862 7.81857 23.3072 8.17413C23.428 8.52961 23.3264 8.91957 23.0454 9.1803L18.2797 13.6021L19.4052 19.8511C19.4715 20.2196 19.312 20.5924 18.9945 20.8122C18.6771 21.0318 18.2564 21.0608 17.9092 20.887L12.018 17.9347L6.12679 20.887C5.77958 21.0608 5.35893 21.0318 5.04156 20.8122C4.72408 20.5924 4.56449 20.2196 4.63083 19.8511L5.75531 13.6021L0.990586 9.1803C0.70963 8.91957 0.607995 8.52961 0.728844 8.17413C0.849844 7.81857 1.1722 7.55869 1.56038 7.50463L8.14825 6.5867L11.0939 0.901691L11.1673 0.781794C11.3577 0.516614 11.6747 0.354004 12.018 0.354004Z"
      style="fill: {selectedColor} !important;"
    />
  </svg>
{:else}
  <svg
    width={size.width}
    height={size.height}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6967 0.778564C12.0891 0.778564 12.4472 0.991026 12.6209 1.32625L15.5655 7.01126L22.1544 7.92919C22.5425 7.98325 22.8649 8.24313 22.9859 8.59869C23.1067 8.95417 23.0051 9.34413 22.7241 9.60486L17.9584 14.0266L19.0839 20.2756C19.1502 20.6442 18.9907 21.017 18.6732 21.2367C18.3558 21.4563 17.9352 21.4854 17.5879 21.3116L11.6967 18.3592L5.8055 21.3116C5.45829 21.4854 5.03764 21.4563 4.72027 21.2367C4.40279 21.017 4.2432 20.6442 4.30954 20.2756L5.43402 14.0266L0.669297 9.60486C0.388341 9.34413 0.286706 8.95417 0.407554 8.59869C0.528555 8.24313 0.850909 7.98325 1.23909 7.92919L7.82696 7.01126L10.7726 1.32625L10.8461 1.20636C11.0364 0.941175 11.3534 0.778564 11.6967 0.778564ZM9.43567 8.34355C9.28566 8.63311 8.99585 8.83395 8.66051 8.88069L3.60182 9.58472L7.26119 12.9811C7.50424 13.2067 7.61539 13.5315 7.55817 13.8502L6.69442 18.646L11.2165 16.3805L11.3323 16.3315C11.6063 16.2328 11.9141 16.2488 12.1769 16.3805L16.698 18.646L15.8353 13.8502C15.7781 13.5315 15.8892 13.2067 16.1323 12.9811L19.7906 9.58472L14.7329 8.88069C14.3976 8.83395 14.1078 8.63311 13.9578 8.34355L11.6967 3.97836L9.43567 8.34355Z"
      style="fill: {unselectedColor} !important;"
    />
  </svg>
{/if}
